import React from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { useGoogleMaps } from '../contexts/GoogleMapsContext';

interface EventMapProps {
  coordinates: {
    latitude: number;
    longitude: number;
  };
}

const mapStyles = [
  {
    "elementType": "geometry",
    "stylers": [{ "color": "#1a1a1a" }]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [{ "color": "#1a1a1a" }]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [{ "color": "#808080" }]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry.stroke",
    "stylers": [{ "color": "#808080" }]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [{ "color": "#2a2a2a" }]
  },
  {
    "featureType": "road",
    "elementType": "geometry.stroke",
    "stylers": [{ "color": "#333333" }]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [{ "color": "#0a0a0a" }]
  }
];

export function EventMap({ coordinates }: EventMapProps) {
  const { isLoaded } = useGoogleMaps();

  if (!isLoaded) return null;

  return (
    <GoogleMap
      zoom={15}
      center={{ lat: coordinates.latitude, lng: coordinates.longitude }}
      mapContainerClassName="w-full h-[300px] rounded-lg"
      options={{
        styles: mapStyles,
        disableDefaultUI: true,
        zoomControl: true,
      }}
    >
      <Marker
        position={{ lat: coordinates.latitude, lng: coordinates.longitude }}
      />
    </GoogleMap>
  );
}